import apiClient from './client';
import type {
  ShoppingList,
  ShoppingListCreate,
  ShoppingListItem,
  ShoppingListItemCreate,
  ShoppingListItemUpdate,
  ShoppingListSuggestion,
} from '../types';

export const shoppingListsApi = {
  /**
   * GET /shopping-lists — Alle zugaenglichen Listen
   */
  list: async (): Promise<ShoppingList[]> => {
    const response = await apiClient.get<ShoppingList[]>('/shopping-lists');
    return response.data;
  },

  /**
   * GET /shopping-lists/{id} — Detail einer Liste mit Items
   */
  get: async (id: string): Promise<ShoppingList> => {
    const response = await apiClient.get<ShoppingList>(`/shopping-lists/${id}`);
    return response.data;
  },

  /**
   * POST /shopping-lists — Neue Liste erstellen
   */
  create: async (data: ShoppingListCreate): Promise<ShoppingList> => {
    const response = await apiClient.post<ShoppingList>('/shopping-lists', data);
    return response.data;
  },

  /**
   * DELETE /shopping-lists/{id} — Liste loeschen
   */
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/shopping-lists/${id}`);
  },

  /**
   * POST /shopping-lists/{listId}/items — Artikel hinzufuegen
   */
  addItem: async (listId: string, data: ShoppingListItemCreate): Promise<ShoppingListItem> => {
    const response = await apiClient.post<ShoppingListItem>(
      `/shopping-lists/${listId}/items`,
      data,
    );
    return response.data;
  },

  /**
   * PUT /shopping-lists/{listId}/items/{itemId} — Artikel aktualisieren (z.B. abhaken)
   */
  updateItem: async (
    listId: string,
    itemId: string,
    data: ShoppingListItemUpdate,
  ): Promise<ShoppingListItem> => {
    const response = await apiClient.put<ShoppingListItem>(
      `/shopping-lists/${listId}/items/${itemId}`,
      data,
    );
    return response.data;
  },

  /**
   * DELETE /shopping-lists/{listId}/items/{itemId} — Artikel entfernen
   */
  deleteItem: async (listId: string, itemId: string): Promise<void> => {
    await apiClient.delete(`/shopping-lists/${listId}/items/${itemId}`);
  },

  /**
   * POST /shopping-lists/{listId}/clear-checked — Alle erledigten Artikel loeschen
   */
  clearChecked: async (listId: string): Promise<ShoppingList> => {
    const response = await apiClient.post<ShoppingList>(
      `/shopping-lists/${listId}/clear-checked`,
    );
    return response.data;
  },

  /**
   * GET /shopping-lists/suggestions?q={q} — Smart-Suggest aus Einkaufshistorie
   */
  suggestions: async (q: string): Promise<ShoppingListSuggestion[]> => {
    const response = await apiClient.get<ShoppingListSuggestion[]>(
      '/shopping-lists/suggestions',
      { params: { q } },
    );
    return response.data;
  },
};
